import api from './api';

const apiKeysService = {
  list: () => api.get('/me/api-keys'),
  create: (name) => api.post('/me/api-keys', { name }),
  revoke: (id) => api.delete(`/me/api-keys/${id}`)
};

export default apiKeysService;
